<div class="step-card" [ngClass]="'theme-' + theme">

  <!-- DESKTOP -->
  <div class="stepper-xl d-none d-xl-flex align-items-center">

    <ng-container *ngFor="let step of uiSteps; let i = index">

      <div
        class="step d-flex flex-column align-items-center justify-content-center"
        [ngClass]="{
          'completed': i < currentStep,
          'current': i === currentStep,
          'pending': i > currentStep,
          'active': i <= currentStep
        }">

        <div
          class="step-icon"
          [ngClass]="{
            'completed': i < currentStep,
            'current': i === currentStep,
            'pending': i > currentStep,
            'active': i <= currentStep
          }">

          <i
            [class]="i < currentStep ? 'fi fi-rr-check' : step.icon"
            [ngClass]="{
              'active': i <= currentStep,
              'completed-icon': i < currentStep,
              'current-icon': i === currentStep,
              'pending-icon': i > currentStep
            }">
          </i>

        </div>

        <small class="step-subtitle">
          PASO {{ i + 1 }}
        </small>

        <small class="step-title">
          {{ step.title }}
        </small>

      </div>

      <div
        *ngIf="i < uiSteps.length - 1"
        class="step-connector"
        [ngClass]="{
          'step-connector-active': i < currentStep
        }">
      </div>

    </ng-container>

  </div>

  <!-- MOBILE -->
  <div class="stepper-mobile d-xl-none p-3">
    <div class="d-flex align-items-center">

      <div class="step-icon mr-3">
        <i [class]="uiSteps[currentStep]?.icon"></i>
      </div>

      <div>
        <div class="text-muted small">
          PASO {{ currentStep + 1 }} de {{ uiSteps.length }}
        </div>

        <div class="h6 m-0 font-weight-bold">
          {{ uiSteps[currentStep]?.title }}
        </div>
      </div>

    </div>

    <div class="progress mt-3">
      <div
        class="progress-bar"
        role="progressbar"
        [style.width.%]="progressPercent()">
      </div>
    </div>
  </div>

</div>